import { BaseUVUnwrapper } from "./UVUnwrapper";
import { XAtlasWebWorker } from "./XAtlasWebWorker";
export class UVUnwrapper extends BaseUVUnwrapper {
    _createXAtlas() {
        return new XAtlasWebWorker();
    }
}
